import { Pipe, PipeTransform } from '@angular/core'
import { PageState } from '@app-types/common.types'

@Pipe({
    name: 'isPageReady',
})
export class IsPageReadyPipe implements PipeTransform {
    transform<T>(value: PageState<T>): value is PageState<T, 'ready'> {
        return value.status === 'ready'
    }
}
